import { createTheme as I } from "./ghl-ui.es827.js";
import H from "./ghl-ui.es1133.js";
import c from "./ghl-ui.es1099.js";
import A from "./ghl-ui.es964.js";
import { changeColor as n } from "./ghl-ui.es863.js";
function a(r, t, o, e) {
  return {
    itemColorHoverInverted: "#0000",
    itemColorActiveInverted: t,
    itemColorActiveHoverInverted: t,
    itemColorActiveCollapsedInverted: t,
    itemTextColorInverted: r,
    itemTextColorHoverInverted: o,
    itemTextColorChildActiveInverted: o,
    itemTextColorChildActiveHoverInverted: o,
    itemTextColorActiveInverted: o,
    itemTextColorActiveHoverInverted: o,
    itemTextColorHorizontalInverted: r,
    itemTextColorHoverHorizontalInverted: o,
    itemTextColorChildActiveHorizontalInverted: o,
    itemTextColorChildActiveHoverHorizontalInverted: o,
    itemTextColorActiveHorizontalInverted: o,
    itemTextColorActiveHoverHorizontalInverted: o,
    itemIconColorInverted: r,
    itemIconColorHoverInverted: o,
    itemIconColorActiveInverted: o,
    itemIconColorActiveHoverInverted: o,
    itemIconColorChildActiveInverted: o,
    itemIconColorChildActiveHoverInverted: o,
    itemIconColorCollapsedInverted: r,
    itemIconColorHorizontalInverted: r,
    itemIconColorHoverHorizontalInverted: o,
    itemIconColorActiveHorizontalInverted: o,
    itemIconColorActiveHoverHorizontalInverted: o,
    itemIconColorChildActiveHorizontalInverted: o,
    itemIconColorChildActiveHoverHorizontalInverted: o,
    arrowColorInverted: r,
    arrowColorHoverInverted: o,
    arrowColorActiveInverted: o,
    arrowColorActiveHoverInverted: o,
    arrowColorChildActiveInverted: o,
    arrowColorChildActiveHoverInverted: o,
    groupTextColorInverted: e
  };
}
const h = (r) => {
  const {
    borderRadius: t,
    textColor3: o,
    primaryColor: e,
    textColor2: i,
    textColor1: l,
    fontSize: C,
    dividerColor: m,
    hoverColor: d,
    primaryColorHover: v
  } = r;
  return Object.assign({
    borderRadius: t,
    color: "#0000",
    groupTextColor: o,
    itemColorHover: d,
    itemColorActive: n(e, {
      alpha: 0.1
    }),
    itemColorActiveHover: n(e, {
      alpha: 0.1
    }),
    itemColorActiveCollapsed: n(e, {
      alpha: 0.1
    }),
    itemTextColor: i,
    itemTextColorHover: i,
    itemTextColorActive: e,
    itemTextColorActiveHover: e,
    itemTextColorChildActive: e,
    itemTextColorChildActiveHover: e,
    itemTextColorHorizontal: i,
    itemTextColorHoverHorizontal: v,
    itemTextColorActiveHorizontal: e,
    itemTextColorActiveHoverHorizontal: e,
    itemTextColorChildActiveHorizontal: e,
    itemTextColorChildActiveHoverHorizontal: e,
    itemIconColor: l,
    itemIconColorHover: l,
    itemIconColorActive: e,
    itemIconColorActiveHover: e,
    itemIconColorChildActive: e,
    itemIconColorChildActiveHover: e,
    itemIconColorCollapsed: l,
    itemIconColorHorizontal: l,
    itemIconColorHoverHorizontal: v,
    itemIconColorActiveHorizontal: e,
    itemIconColorActiveHoverHorizontal: e,
    itemIconColorChildActiveHorizontal: e,
    itemIconColorChildActiveHoverHorizontal: e,
    itemHeight: "42px",
    arrowColor: i,
    arrowColorHover: i,
    arrowColorActive: e,
    arrowColorActiveHover: e,
    arrowColorChildActive: e,
    arrowColorChildActiveHover: e,
    colorInverted: "#0000",
    borderColorHorizontal: "#0000",
    fontSize: C,
    dividerColor: m
  }, a("#BBB", e, "#FFF", "#AAA"));
}, z = I({
  name: "Menu",
  common: H,
  peers: {
    Tooltip: c,
    Dropdown: A
  },
  self: h
}), f = z;
export {
  a as createPartialInvertedVars,
  f as default,
  h as self
};
